import React, { Component } from 'react';
import 'react-vis/dist/style.css';
import {XYPlot, LineSeries, VerticalGridLines, HorizontalGridLines, XAxis, YAxis} from 'react-vis';
import {timeFormatDefaultLocale} from 'd3-time-format';
import { Dropdown } from 'reactjs-dropdown-component';
import http from "../services/httpService";
import config from "../config.json";


class Chart extends Component {
    constructor() {
        super();
        this.dropdownCurrencyRef = React.createRef();
        this.dropdownTimeRef = React.createRef();

        this.state = {  
            values: [],
            currencies: [],
            height: 0,
            width: 0,
            currency: '1',
            range: '1'
        }
    }
    

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);

        this.setLabels();

        setTimeout(() => {
            this.dropdownCurrencyRef.current.selectSingleItem({ value: '1' });
            this.dropdownTimeRef.current.selectSingleItem({ value: '1' });
        }, 1000)

        this.setValues();
        this.interval = setInterval(() => this.setValues(), 60000);
    }
    
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        var minus = 50;
        if(document.getElementById("chart").offsetWidth < 500)
            minus = 20;
        this.setState({width: document.getElementById("chart").offsetWidth - minus, height: document.getElementById("chart").offsetWidth / 2 * 0.7});
    };

    async setLabels(){

        if(JSON.parse(localStorage.getItem('currencies')) !== null){
            this.setState({currencies:JSON.parse(localStorage.getItem('currencies'))});
        }
        else{
            var {data : currencies} =  await http.get(config.apiEndpoint + 'Chart/Labels');
            localStorage.setItem('currencies', JSON.stringify(currencies));
            this.setState({currencies})
        }
    }

    async setValues(currency,range){
        if(currency === undefined){
            currency = this.state.currency;
            range = this.state.range;
        }

        //var {data : valuesm} =  await http.get(config.apiEndpoint + 'Chart/' + currency + '/' + range);
        var {data : valuesm} =  await http.get(config.restEndpoint + 'chart/' + currency + '_' + range + '.json');
        var values = [];
        
        for(let i = 0; i <= valuesm.length; i++) {
            if(valuesm[i] !== undefined){
                let date = new Date(valuesm[i].x);
                values.push({x : date, y : valuesm[i].y})
            }
        }

        this.setState({values})
    }

    onChange = (item, name) => {
        if(name === 'currency'){
            this.setState({currency: item.value});
            this.setValues(item.value, this.state.range);
        }
        else if(name === 'range'){
            this.setState({range: item.value});
            this.setValues(this.state.currency ,item.value);
        }
    }

    render() { 
        var range = this.state.range;

        timeFormatDefaultLocale({
            dateTime    : '%a %b %e %X %Y',
            date        : '%d/%m/%Y',
            time        : '%HH:%mm:%ss',
            periods     : ['',''],
            days        : ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
            shortDays   : ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
            months      : ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Decembre'],
            shortMonths : ['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Dec']
        });

        const ranges = [
            {
              label: 'Günlük',
              value: '1',
            },
            {
              label: 'Haftalık',
              value: '7',
            },
            {
              label: 'Aylık',
              value: '30',
            },
            {
              label: '6 Aylık',
              value: '180',
            },
            {
              label: 'Yıllık',
              value: '365',
            },
            {
              label: '5 Yıllık',
              value: '1825',
            },
            {
              label: 'Mak',
              value: '100000',
            }
          ];

        return <div id="chart" className="card" style={{height:this.state.height + 120 }}>
            <div className="card-header">
		    <div className="card-action">
                <Dropdown
                    name="currency"
                    ref={this.dropdownCurrencyRef}
                    title="Kur Seçiniz"
                    searchable={["Kur", "Kur bulunamadı"]}
                    list={this.state.currencies}
                    onChange={this.onChange}
                    styles={{
                        wrapper:{ width: 212, paddingLeft:10, marginRight:10},
                        headerTitle: { color: 'white', fontSize: '1.0rem' },
                        header:{ backgroundColor: '#2e2a26'},
                        headerArrowUpIcon: { borderColor: 'white'},
                        headerArrowDownIcon: { fill: 'white'},
                        list:{ backgroundColor: '#2e2a26'},
                        listSearchBar:{ backgroundColor: '#2e2a26',color: 'white', fontSize: '1.0rem'},
                        listItem:{ fontWeight: 400, fontSize:'1rem'},
                        scrollList:{ backgroundColor: '#2e2a26'},
                      }}
                />
                <Dropdown
                    name="range"
                    ref={this.dropdownTimeRef}
                    title="Zaman"
                    list={ranges}
                    onChange={this.onChange}
                    styles={{
                        wrapper:{ width: 150},
                        headerTitle: { color: 'white', fontSize: '1.0rem' },
                        header:{ backgroundColor: '#2e2a26'},
                        headerArrowUpIcon: { borderColor: 'white'},
                        headerArrowDownIcon: { fill: 'white'},
                        list:{ backgroundColor: '#2e2a26'},
                        listSearchBar:{ backgroundColor: '#2e2a26',color: 'white', fontSize: '1.0rem'},
                        listItem:{ fontWeight: 400, fontSize:'1rem'},
                        scrollList:{ backgroundColor: '#2e2a26'},
                      }}
                />
		   </div>
		 </div>
            <div className="card-body chart">
                <XYPlot height={this.state.height} width={this.state.width} xType="time" margin={{left: 60, right: 0, top: 0, bottom: range === '1' ? 55 : 60}}>
                    <VerticalGridLines />
                    <HorizontalGridLines />
                    <XAxis tickFormat={function tickFormat(timestamp) {
                        const date = new Date(timestamp);
                        var tzoffset = (date.getTimezoneOffset() + 360) * 60000;
                        var localISOTime = (new Date(date - tzoffset)).toString();
                        return range === '1' ? localISOTime.substring(16,21) : date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear()
                    }} tickLabelAngle={-65}/>
                    <YAxis  />
                    <LineSeries data={this.state.values} style={{stroke: 'white', strokeWidth: 2}}/>
                </XYPlot>
            </div>
        </div>;
    }

}
 
export default Chart;